export default __webpack_public_path__ + "static/media/people2.ffd08284.png";